import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import * as Project from 'projects/components/form';

const ProjectsFormView = ({
  t,
  project,
  company,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  isSubmitted,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("projects.title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('projects.title') +
          ' > ' +
          t(project.id ? 'projects.edit' : 'projects.add')
        }
        icon={'archive'}
      >
        <Project.Form
          company={company}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSaving={isSaving}
          isSubmitted={isSubmitted}
          subcompany={subcompany}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
          values={project}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(ProjectsFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/ProjectFormView.js